/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20kc09ee%7B0%25%7Bbackground-position%3A50%25%200%7Dto%7Bbackground-position%3A-50%25%200%7D%7D%0A._0bjKvDcjp5%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D%0A._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D%0A._0KLXruaVjy%7Bbackground-color%3Avar(--ds-skeleton-subtle%2C%2317171708)%7D%0A._3CkH9ozuPt%7Bbackground-image%3Alinear-gradient(to%20right%2Ctransparent%200%2Cvar(--ds-skeleton%2C%230515240f)%2020%25%2Ctransparent%2040%25%2Ctransparent%20100%25)%7D%0A._2z4m57UZDI%7Bbackground-repeat%3Ano-repeat%7D%0A._3OqcjTLH3G%7Bbackground-size%3A280%25%20100%25%7D%0A._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D%0A._0nFVCGipXj%7Banimation-duration%3A1s%7D%0A._3Y6bKpgRhm%7Banimation-fill-mode%3Aforwards%7D%0A._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D%0A._1gBibyHvL7%7Banimation-name%3Akc09ee%7D%0A._43vdfTHVQb%7Banimation-timing-function%3Alinear%7D");












import type { LoadingSkeletonProps } from './types';
const animationNameStyles = null;
const loadingSkeletonStyle = null;
export const LoadingSkeleton = ({
  testId,
  width,
  height
}: LoadingSkeletonProps): JSX.Element => {
  return <span data-testid={testId} style={{
    width,
    height
  }} className={ax(["_0bjKvDcjp5 _20VacPYbGa _0KLXruaVjy _3CkH9ozuPt _2z4m57UZDI _3OqcjTLH3G _3iDTPbvbI6 _0nFVCGipXj _3Y6bKpgRhm _03m2nySHWH _1gBibyHvL7 _43vdfTHVQb"])} />;
};